// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"8f206d00","286":"0d4123f6","445":"498adf25","661":"d1779429","820":"240c1074","890":"66e79d43","892":"52ce40d2","926":"796c4856"}[chunkId] + ".chunk.css";
};